import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./TreasureLink.module.css";

const HREFS = {
  login: "https://teacher-treasure.pages.dev/?from=eduseed-login",
  home: "https://teacher-treasure.pages.dev/?from=eduseed-home",
};

export function TreasureLink({ placement }) {
  const { t } = useTranslation();
  const href = HREFS[placement];
  if (!href) return null;

  const className = [
    styles.link,
    placement === "home" ? styles.home : styles.login,
  ].join(" ");

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      <span aria-hidden="true">✨</span>
      {t("common.uniComponents.treasureLinkLabel")}
      <span className={styles.badge}>NEW</span>
    </a>
  );
}
